<template>
    <div>
        <h2>{{monthName}} {{year}} <br /><small>Completed {{tasks_this_month.length}}</small></h2>
        <ul>
            <li v-for="task in tasks_this_month"><b>{{task.project}}</b> {{task.title}} <small v-if="task.tags">{{task.tags}}</small></li>
        </ul>
    </div>
</template>

<script>
 const monthNames = ["January", "February", "March", "April", "May", "June",
                     "July", "August", "September", "October", "November", "December"
 ];

 export default {
     name: 'Month',
     props: {
         month: Number,
         year: Number,
         tasks: Array,
     },
     computed: {
         tasks_this_year: function () {
             return this.tasks.filter( (e) => {
                 return e.date.indexOf( this.year ) !==-1
             })
         },
         tasks_this_month: function() {
             return this.tasks_this_year.filter( (e) => {
                 return e.date.indexOf( monthNames[this.month-1] ) !==-1
             })
         },
         monthName: function() {
             return monthNames[this.month-1]
         }
     }
 }
</script>

<style>
 ul{
 padding: 0 1em;
}
 small{
     display: inline-block;
     background: #ccc;
     padding: 0 0.5em;
     border-radius: 0.5em;
 }
</style>
